import { useCallback } from 'react';
import { getBackendAppToolsExtensionsDir } from '@wix/cli-astro-definitions';
import {
  composeValidations,
  pathAvailableValidation,
  pathValidation,
  useValidation,
} from './common.js';

function createAppToolsNameValidation(projectFolder: string) {
  const extensionsDir = getBackendAppToolsExtensionsDir(projectFolder);
  return composeValidations([
    [
      (value: string) => value.length < 20,
      "Name must be unique, can't include special characters or spaces, and must be shorter than 20 characters",
    ],
    [
      pathValidation,
      "Name must be unique, can't include special characters or spaces, and must be shorter than 20 characters",
    ],
    [
      pathAvailableValidation(extensionsDir),
      'An app tools extension with this name already exists.',
    ],
  ]);
}

export const useAppToolsNameValidation = (projectFolder: string) => {
  const validation = useValidation(createAppToolsNameValidation(projectFolder));

  return useCallback(validation, [validation, projectFolder]);
};
